export let ImageType = /*#__PURE__*/function (ImageType) {
  ImageType[ImageType["IMAGE"] = 0] = "IMAGE";
  ImageType[ImageType["FONT_BASED"] = 1] = "FONT_BASED";
  ImageType[ImageType["SVG"] = 2] = "SVG";
  return ImageType;
}({});
//# sourceMappingURL=ImageType.js.map
